import React, { useState } from "react";
import { Box, Container } from "@material-ui/core";
import { VFlex } from "shared";
import { useGetUsers } from "./useGetUsers";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { SearchUserForm } from "./SearchUserForm";
import { GetUsersParams } from "./schema";

const PAGE_SIZE = 25;

const columns: GridColDef[] = [
  { field: "id", headerName: "ID", flex: 1 },
  { field: "role", headerName: "Role", flex: 1 },
  { field: "state", headerName: "State", flex: 1 },
  { field: "ce_structure", headerName: "CE structure", flex: 1 },
  { field: "personal_number", headerName: "Personal number", flex: 1 },
  { field: "first_name", headerName: "First name", flex: 1 },
  { field: "last_name", headerName: "Last name", flex: 1 },
  { field: "phone_number", headerName: "Phone number", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
];

export const Users: React.FC = () => {
  const [filters, setFilters] = useState<GetUsersParams | undefined>(undefined);
  const [page, setPage] = useState(0);

  const args = filters ? { ...filters, limit: PAGE_SIZE, page: page + 1 } : undefined;
  const { data, isFetching } = useGetUsers(args);
  const rows = data?.items || [];

  return (
    <VFlex>
      <Container maxWidth="md">
        <Box mb={3} style={{ marginTop: "108px" }}>
          <SearchUserForm setFilters={setFilters} loading={isFetching} />
        </Box>
      </Container>

      <Box bgcolor="background.paper" padding={2} overflow="auto" data-testid="search-results">
        {/* {isError && <ErrorBox error={error!} verbose centered dark />} */}
        {/* {isLoading && <Loading />} */}
        {/* {isSuccess && (!!(data as any)?.items.length ? tableEm : noMatchEm)} */}
        <DataGrid
          columns={columns}
          rows={rows}
          rowCount={data?.metadata?.total_count || 0}
          paginationMode="server"
          pageSize={PAGE_SIZE}
          onPageChange={page => setPage(page)}
          loading={isFetching}
          disableSelectionOnClick
          autoHeight
        />
      </Box>
    </VFlex>
  );
};
